import classNames from 'classnames';
import React from 'react';

import Tooltip, {TooltipPlacement, TooltipProps} from 'ui-library/bs/Tooltip';
import Button, {ButtonProps, ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

export type DataFrameActionButtonProps = Pick<ButtonProps, 'icon' | 'disabled' | 'onClick'> &
  Pick<TooltipProps, 'title'> & {toggled?: boolean};

export default function DataFrameActionButton(props: DataFrameActionButtonProps): JSX.Element {
  return (
    <Tooltip title={props.title} placement={TooltipPlacement.TOP}>
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        className={classNames('u-mini-spacing-left', Boolean(props.toggled) && 'is-active')}
        disabled={props.disabled}
        icon={props.icon}
        onClick={props.onClick}
        size={ButtonSize.MINI}
      />
    </Tooltip>
  );
}
